import style from "./ImgGrid.module.css";
import Img, { ImgProps } from "@/components/Img";

import { FC } from "react";

export interface Props extends ImgProps {
  images?: string[];
}

const ImgGrid: FC<Props> = ({ images, ...props }) => {
  return (
    <div className={style.ImgGrid}>
      {images?.map((src, index) => (
        <Img key={index} {...props} src={src} />
      ))}
    </div>
  );
};

export default ImgGrid;
